var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 3.24992H20.5834V1.08325H18.4167V3.24992H7.58335V1.08325H5.41669V3.24992H4.33335C3.14169 3.24992 2.16669 4.22492 2.16669 5.41659V22.7499C2.16669 23.9416 3.14169 24.9166 4.33335 24.9166H21.6667C22.8584 24.9166 23.8334 23.9416 23.8334 22.7499V5.41659C23.8334 4.22492 22.8584 3.24992 21.6667 3.24992ZM21.6667 22.7499H4.33335V10.8333H21.6667V22.7499ZM21.6667 8.66659H4.33335V5.41659H21.6667V8.66659Z",
    fill: "#1034A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.d414b8d8980b709a2e5e0fe53988421e.svg";
export { ForwardRef as ReactComponent };